// For full API documentation, including code examples, visit https://wix.to/94BuAAs

$w.onReady(function () {
	// Hides the element when the page loads
$w("#image13").hide();
$w("#image14").hide();
$w("#image15").hide();
$w("#image16").hide();
$w("#image17").hide();
$w("#image18").hide();
$w("#image19").hide();
$w("#image20").hide();
$w("#image21").hide();
$w("#image22").hide();
$w("#image23").hide();
$w("#image24").hide();
$w("#image25").hide();
$w("#image26").hide();
$w("#image27").hide();
$w("#image28").hide();
$w("#image29").hide();
$w("#image30").hide();
$w("#image31").hide();
$w("#image32").hide();
$w("#image33").hide();
$w("#image34").hide();
$w("#image35").hide();
$w("#image36").hide();
$w("#image37").hide();
$w("#image38").hide();
$w("#image39").hide();
$w("#text30").hide();
$w("#text31").hide();
$w("#text32").hide();
$w("#text33").hide();
$w("#text34").hide();
$w("#text35").hide();
$w("#text36").hide();
$w("#text37").hide();
$w("#text38").hide();
$w("#text39").hide();
$w("#text40").hide();
$w("#text41").hide();
$w("#text42").hide();
$w("#text43").hide();
$w("#text44").hide();
$w("#text45").hide();
$w("#text46").hide();
$w("#text47").hide();
$w("#text48").hide();
$w("#text49").hide();
$w("#text50").hide();
$w("#text51").hide();
$w("#text52").hide();
$w("#text53").hide();
$w("#text54").hide();
$w("#text55").hide();
$w("#text56").hide();
$w("#text62").hide();
$w("#text63").hide();
$w("#text74").hide();
$w("#text77").hide();

});

